import React, { useEffect, useMemo, useState } from 'react';
import { Container, Box, Skeleton } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';

// const valueFormatter = (value) => `${value}`;

export default function HorizontalBarChart({ averageEnergyUsageBaselineDay, averageEnergyUsageControlDay, baseUnit, loading }) {

  const [baselineUsage, setBaselineUsage] = useState(0);
  const [controlUsage, setControlUsage] = useState(0);
  const [base, setBase] = useState(baseUnit);

  useEffect(() => {
    setBaselineUsage(averageEnergyUsageBaselineDay)
    setControlUsage(averageEnergyUsageControlDay)
    setBase(baseUnit)
  }, [averageEnergyUsageBaselineDay, averageEnergyUsageControlDay])


  return (
    <>
      {loading ? (
        <Skeleton variant="rounded" height={400} />
      ) : (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" m={2} width="100%">
          <BarChart
            borderRadius={1}
            dataset={[
              {
                baselineAverage: Math.round(baselineUsage),
                controlAverage: Math.round(controlUsage),
                base: base
              }
            ]}
            yAxis={[{ scaleType: 'band', dataKey: 'base' }]}
            series={[
              {
                dataKey: 'controlAverage',
                label: 'Gennemsnitsforbrug under optimering pr. døgn på 24 timer',
                valueFormatter: (value) => `${value} ${base}`,
                color: 'hsl(63, 100%, 40%)',
                tooltip: 'jhvad'
              },
              {
                dataKey: 'baselineAverage',
                label: 'Gennemsnitsforbrug uden optimering (baseline-dage) på 24 timer',
                valueFormatter: (value) => `${value} ${base}`,
                color: 'hsl(10, 85%, 47%)',
              }
            ]}
            height={200} // Adjust as needed
            minWidth={600}
            margin={{ top: 80, bottom: 30 }}
            layout="horizontal"
          />
        </Box>
      )}
    </>
  );
}